import { createContext, useContext, useMemo } from "react";
import type { ReactNode } from "react";

type LayoutScrollContextValue = {
  scrollToTop: (options?: LayoutScrollToTopOptions) => void;
};

export type LayoutScrollToTopOptions = {
  animated?: boolean;
};

const LayoutScrollContext = createContext<LayoutScrollContextValue | undefined>(
  undefined,
);

type LayoutScrollProviderProps = {
  children: ReactNode;
  scrollToTop: LayoutScrollContextValue["scrollToTop"];
};

export const LayoutScrollProvider = ({
  children,
  scrollToTop,
}: LayoutScrollProviderProps) => {
  const value = useMemo(() => ({ scrollToTop }), [scrollToTop]);

  return (
    <LayoutScrollContext.Provider value={value}>
      {children}
    </LayoutScrollContext.Provider>
  );
};

export const useLayoutScroll = () => {
  const context = useContext(LayoutScrollContext);

  if (!context) {
    throw new Error("useLayoutScroll must be used within LayoutScrollProvider");
  }

  return context;
};
